import {ICellRenderer} from 'ag-grid-community';
import {Tooltip} from 'platform/components';
import {Box, Icon} from 'platform/foundation';
import {match} from 'ts-pattern';

import {forwardRef} from 'react';

import {isNil} from 'ramda';

import {useTooltipProps} from '../../hooks/useTooltipProps';
import {ICellRendererParams} from '../../types/AgGridTypes';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getUnformattedValue} from '../../utils/getUnformattedValue';

export interface CheckboxCellRendererParams extends ICellRendererParams {
  getTooltipProps?: TooltipGetter;
}

function CheckboxCellRendererComponent(
  props: CheckboxCellRendererParams,
  _ref: React.Ref<ICellRenderer>
) {
  const tooltipProps = useTooltipProps(props.data, props.node, props.getTooltipProps);
  const value = getUnformattedValue(props);

  if (isNil(value)) {
    return null;
  }

  return (
    <Tooltip {...tooltipProps}>
      <Box css={{display: 'inline-flex'}}>
        {match(!!value)
          .with(true, () => <Icon value="action/check_circle" size={6} color="severity.success" />)
          .with(false, () => <Icon value="navigation/cancel" size={6} color="severity.danger" />)
          .exhaustive()}
      </Box>
    </Tooltip>
  );
}

export const CheckboxCellRenderer = forwardRef<ICellRenderer, CheckboxCellRendererParams>(
  CheckboxCellRendererComponent
);
